(function () {
    var HIGHLIGHT_CLASS = 'search-highlight';

    function clearHighlights() {
        try {
            var marks = document.querySelectorAll('mark.' + HIGHLIGHT_CLASS);
            for (var i = marks.length - 1; i >= 0; i--) {
                var mark = marks[i];
                var parent = mark.parentNode;
                if (!parent) continue;
                parent.replaceChild(document.createTextNode(mark.textContent), mark);
                parent.normalize();
            }
        } catch (e) { /* no-op */ }
    }

    function highlightTextNode(textNode, re) {
        var parent = textNode.parentNode;
        if (!parent) return null;

        var text = textNode.nodeValue;
        var fragment = document.createDocumentFragment();
        var firstMark = null;
        var lastIndex = 0;
        var match;

        re.lastIndex = 0;
        while ((match = re.exec(text)) !== null) {
            if (match.index > lastIndex) {
                fragment.appendChild(document.createTextNode(text.slice(lastIndex, match.index)));
            }
            var mark = document.createElement('mark');
            mark.className = HIGHLIGHT_CLASS;
            mark.style.cssText = 'background-color:#fff3b0;padding:0;border-radius:2px;';
            mark.appendChild(document.createTextNode(match[0]));
            fragment.appendChild(mark);
            if (!firstMark) {
                firstMark = mark;
            }
            lastIndex = re.lastIndex;
        }

        if (lastIndex < text.length) {
            fragment.appendChild(document.createTextNode(text.slice(lastIndex)));
        }

        parent.replaceChild(fragment, textNode);
        return firstMark;
    }

    window.searchHelpers = {
        /**
         * Highlight every occurrence of query inside <main> by wrapping matched text
         * nodes with <mark> elements, then scroll to the first match. Best-effort; will not throw.
         * @param {string} query
         */
        scrollToFirstMatch: function (query) {
            clearHighlights();
            if (!query) return;
            try {
                var escaped = String(query).replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
                var reTest    = new RegExp(escaped, 'i');
                var reReplace = new RegExp(escaped, 'gi');

                var main = document.querySelector('main');
                if (!main) return;

                // Collect matching text nodes before modifying the DOM
                var walker = document.createTreeWalker(main, NodeFilter.SHOW_TEXT, null);
                var nodesToProcess = [];
                var node;
                while ((node = walker.nextNode())) {
                    var parentTag = node.parentNode ? node.parentNode.nodeName : '';
                    if (parentTag === 'SCRIPT' || parentTag === 'STYLE') continue;
                    if (reTest.test(node.nodeValue)) {
                        nodesToProcess.push(node);
                    }
                }

                var firstMark = null;
                for (var i = 0; i < nodesToProcess.length; i++) {
                    var mark = highlightTextNode(nodesToProcess[i], reReplace);
                    if (!firstMark && mark) {
                        firstMark = mark;
                    }
                }

                if (firstMark) {
                    firstMark.scrollIntoView({ behavior: 'smooth', block: 'center' });
                }
            } catch (e) {
                console && console.error('searchHelpers.scrollToFirstMatch error', e);
            }
        },

        /** Remove all highlights added by scrollToFirstMatch. */
        clearHighlights: function () {
            clearHighlights();
        }
    };
})();